import React, {useContext, useState} from 'react'
import {Link} from 'react-router-dom'

import './css/navbar.css'

import Search from '../search/Search'
import UserContext from '../../UserContext'
import DataContext from '../../DataContext'

const MobileNavbar = ({showButtons}) => {

    const {user} = useContext(UserContext);
    const {data} = useContext(DataContext);
    const [open, setOpen] = useState(false);

    return (
        <nav className="main-nav">
            <div className="container">
                <div className="logo">
                    <div>
                        <Link to={`${process.env.PUBLIC_URL}/`}>{data.config.navTitle}</Link>
                    </div>
                </div>
                { !showButtons ? <div></div> : (
                <div>
                    <button className="hamburger-button hover-tile" onClick={() => setOpen(!open)}>{open ? "X" : "☰" }</button>
                </div>
                )}
            </div>
            { !open ? null : (
                <div className="hamburger-interior">
                    <Search />
                        <ul>
                            <li><Link onClick={() => setOpen(false)} to={`${process.env.PUBLIC_URL}/timeline`}>Timeline</Link></li>
                            {data.config.showEffortsTimeline ? <li><Link to={`${process.env.PUBLIC_URL}/efforts`}>Efforts</Link></li> : null}
                            <li><Link onClick={() => setOpen(false)} to={`${process.env.PUBLIC_URL}/projects`}>Projects</Link></li>
                            <li><Link onClick={() => setOpen(false)} to={`${process.env.PUBLIC_URL}/entries`}>Entries</Link></li>
                        </ul>
                        { user
                            ? (<ul>
                                <li><Link onClick={() => setOpen(false)} to={`${process.env.PUBLIC_URL}/entries/add`}>Add Entry</Link></li>
                                <li><Link onClick={() => setOpen(false)} to={`${process.env.PUBLIC_URL}/dashboard`}>Dashboard</Link></li>
                                <li><Link onClick={() => setOpen(false)} to={`${process.env.PUBLIC_URL}/logout`}>Logout</Link></li>
                            </ul>)
                            : (<ul>
                                <li><Link onClick={() => setOpen(false)} to={`${process.env.PUBLIC_URL}/login`}>Login</Link></li>
                            </ul>)
                        }
                </div>
            )}
        </nav>
    )
}

export default MobileNavbar;
